import { Card, CardContent, Button, Loader } from '@/shared/components';
import { useVerificationStatus } from './model/useVerificationStatus';
import { cn } from '@/shared/utils';
import { useContactUs } from '@/shared/lib';
import { useVerificationModal } from '@/features/user-verification/model';
import { Trans } from 'react-i18next';

type Props = {
  ewalletAccNum: string | undefined;
  className?: string;
};

const VerificationCta = ({ ewalletAccNum, className }: Props) => {
  const { openVerificationModal } = useVerificationModal();

  const {
    icon,
    title,
    description,
    buttonText,
    isLoading,
    isVerificationRejected,
    isCorporateSuccess,
  } = useVerificationStatus();

  const { links } = useContactUs({ ewalletAccNum });

  return (
    <Card className={className}>
      <CardContent
        className={cn(
          'flex flex-col items-center justify-end pb-[3.2rem] gap-[2.4rem] h-[30rem] max-w-[42rem] self-center',
          isLoading && 'justify-center'
        )}>
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <img src={icon} className="w-[5.6rem]" alt="Verification status" />
            <div className="flex flex-col items-center justify-center gap-[0.8rem]">
              <span className="headline4 text-center">{title}</span>
              <p className="p4 text-center text-secondary">
                {isCorporateSuccess ? (
                  <Trans
                    i18nKey="personalAccount.verificationCta.corporateSuccessDescription"
                    components={{
                      email: <span className="text-primary font-medium" />,
                    }}
                  />
                ) : (
                  description
                )}
              </p>
            </div>
            {buttonText && (
              <Button
                size="lg"
                onClick={() => {
                  if (isCorporateSuccess) {
                    window.open(
                      links?.verificationForCorporate || '',
                      '_blank'
                    );
                  } else if (isVerificationRejected) {
                    window.open(links?.defaultRequest || '', '_blank');
                  } else {
                    openVerificationModal();
                  }
                }}>
                {buttonText}
              </Button>
            )}
          </>
        )}
      </CardContent>
    </Card>
  );
};

export { VerificationCta };
